import axios from "axios";

const useRequestsAfter3Dcheck = () => {
  const isBrowser = typeof window !== "undefined";

  const purchaseEventHandler = (data) => {
    if (isBrowser) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    }
  };

  const sendRequests = async () => {
    const rawSavedData = localStorage.getItem("savedData");
    if (rawSavedData) {
      let savedData = { ...JSON.parse(rawSavedData) };
      try {

        const getTransactionResponse = await axios.post("/api/opayoHandler", {
          type: "getTransactionResponse",
          data: savedData.formatedData.reference,
        });

        if (getTransactionResponse.data) {
          //formatedData
          savedData.formatedData.method =
            getTransactionResponse.data.paymentMethod.card.cardType.toUpperCase();

          savedData.formatedData.amount =
            getTransactionResponse.data.amount.totalAmount / 100;

          savedData.formatedData.comment =
            getTransactionResponse.data.transactionType;

          savedData.formatedData.currencycode =
            getTransactionResponse.data.currency;

          //paymentEventData
          savedData.paymentEventData.value =
            getTransactionResponse.data.amount.totalAmount / 100;

          savedData.paymentEventData.currency =
            getTransactionResponse.data.currency;

          savedData.paymentEventData.transaction_id =
            getTransactionResponse.data.transactionId;

          const paymentToDarwin = await axios.post(
            "/api/postPaymentToDarwin",
            savedData.formatedData
          );

         /*  const saveDataToSanity = await axios.post(
            "/api/postEnquiryDataInSanity",
            {
              ...savedData.emailData,
              noOfAdults:
                savedData.emailData.noOfAdults !== undefined ||
                savedData.emailData.noOfAdults !== null
                  ? String(savedData.emailData.noOfAdults)
                  : null,
              noOfNights:
                savedData.emailData.noOfAdults !== undefined ||
                savedData.emailData.noOfNights !== null
                  ? String(savedData.emailData.noOfNights)
                  : null,
              noOfSinglerooms:
                savedData.emailData.noOfSinglerooms !== undefined ||
                savedData.emailData.noOfSinglerooms !== null
                  ? String(savedData.emailData.noOfSinglerooms)
                  : null,
              noOfDoubleTwinrooms:
                savedData.emailData.noOfDoubleTwinrooms !== undefined ||
                savedData.emailData.noOfDoubleTwinrooms !== null
                  ? String(savedData.emailData.noOfDoubleTwinrooms)
                  : null,
              transactionId: getTransactionResponse.data.transactionId,
              uuid: getTransactionResponse.data.transactionId,
            }
          ); */

          savedData.emailData.paymentStatus = "Confirmed";

          const responseEmail = await axios.post(
            "/api/enquiryFormSendEmail",
            savedData.emailData
          );

          purchaseEventHandler(savedData.paymentEventData);
        }
      } catch (error) {
        savedData.emailData.paymentStatus =
          "ERROR. Your payment is being failed.";
        const responseEmail = await axios.post(
          "/api/enquiryFormSendEmail",
          savedData.emailData
        );
        console.error("An error occurred:", error);
      }
    }

    localStorage.removeItem("savedData");
  };

  return sendRequests;
};

export default useRequestsAfter3Dcheck;
